<template>
  <div :class="$style.page">
    default404
  </div>
</template>

<script>

export default {
  name: 'Default'

}
</script>

<style module>
.page {
    min-height: 100vh;
}

</style>
